import React from "react";
import OutputDetails from "./OutputDetails";

const OutputWindow = ({ outputs }) => {
  const getOutput = (outputDetails) => {
    let statusId = outputDetails?.status?.id;

    if (statusId === 6) {
      // compilation error
      return (
        <pre className="px-2 py-1 font-normal text-xs text-red-500">
          {atob(outputDetails?.compile_output)}
        </pre>
      );
    } else if (statusId === 3) {
      return (
        <pre className="px-2 py-1 font-normal text-xs text-green-500">
          {atob(outputDetails.stdout) !== null
            ? `${atob(outputDetails.stdout)}`
            : null}
        </pre>
      );
    } else if (statusId === 4) {
      return (
        <div className="flex gap-8 mt-2">
          <div>
            <pre>Your output</pre>
            <pre className="px-2 py-1 font-normal text-xs text-red-500">
              {atob(outputDetails?.stdout)}
            </pre>
          </div>
          <div>
            <pre>Expected output</pre>
            <pre className="px-2 py-1 font-normal text-xs text-green-500">
              {outputDetails.expected_output !== null
                ? `${outputDetails.expected_output}`
                : null}
            </pre>
          </div>
        </div>
      );
    } else if (statusId === 5) {
      return (
        <pre className="px-2 py-1 font-normal text-xs text-red-500">
          {`Time Limit Exceeded`}
        </pre>
      );
    } else {
      return (
        <pre className="px-2 py-1 font-normal text-xs text-red-500">
          {outputDetails?.stderr}
        </pre>
      );
    }
  };
  return (
    <div className="w-[50%] flex flex-col">
      <h1
        className="flex items-center justify-start font-bold 
        text-base w-full bg-black-glaze text-white pl-5 py-3"
      >
        Output
      </h1>
      <div className="problem-container w-full h-[220px] overflow-auto bg-body-black px-8 pt-6 text-white font-normal text-sm">
        {outputs?.map((outputDetails, index) =>
          outputDetails ? (
            <div className={`${index !== 0 ? "mt-8" : ""}`}>
              <pre className={`font-bold text-md text-white`}>
                {`Test-Case ${index + 1}`}
                {outputDetails.status?.id === 3 ? (
                  <span className="px-2 py-1 font-normal text-md text-green-500">
                    {outputDetails.status?.description}
                  </span>
                ) : null}
                {[4, 11].includes(outputDetails.status?.id) ? (
                  <span className="px-2 py-1 font-normal text-md text-red-500">
                    {outputDetails.status?.description}
                  </span>
                ) : null}
              </pre>
              {getOutput(outputDetails)}
              <br />
              {outputDetails && <OutputDetails outputDetails={outputDetails} />}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default OutputWindow;
